import Icon from '@atoms/Icon/Icon';
import Tooltip from '@atoms/Tooltip/Tooltip';
import TooltipPositionEnum from '@models/enums/TooltipPositionEnum';

interface Props {
  readonly infoTooltip: string;
}

const FormFieldInfoTooltip = ({ infoTooltip }: Props) => (
  <div className="flex items-center">
    <div className="tooltip-parent relative flex">
      <Icon name="info" size="0.875rem" />
      <Tooltip
        label={infoTooltip}
        position={TooltipPositionEnum.Custom}
        customWrapperClassName="top-0"
        customContentClassName="-translate-y-2 bottom-0 right-0 lg:left-0 lg:right-auto"
        backgroundColor="bg-grey-100"
      />
    </div>
  </div>
);

export default FormFieldInfoTooltip;
